import ContentLoader from 'react-content-loader';
import { nafColor } from '@nafcore/theme';
import React from 'react';
import styled from '@emotion/styled';

export const SearchResultListItemLoader = () => (
  <Wrapper>
    <ContentLoader
      uniqueKey="article-loader"
      width="100%"
      viewBox="0 0 450 500"
      preserveAspectRatio="xMidYMid meet"
      backgroundColor={nafColor.neutral.neutral1}
      foregroundColor={nafColor.neutral.neutral2}
    >
      <rect x="0" y="0" rx="0" ry="0" width="110" height="83" />
      <rect x="130" y="0" rx="4" ry="4" width="50%" height="28" />
      <rect x="130" y="38" rx="3" ry="3" width="100%" height="20" />
      <rect x="130" y="68" rx="3" ry="3" width="50%" height="12" />
    </ContentLoader>
  </Wrapper>
);

const Wrapper = styled.div`
  overflow: hidden;
  height: auto;
  border-bottom: 1px solid ${nafColor.neutral.neutral1};
  padding-bottom: 10px;
  margin-bottom: 16px;
  max-height: 140px;
`;
